<label class="switch">
    <input *ngIf="!disabled && value " type="checkbox" checked (change)="onValueChanged()">
    <input *ngIf="!disabled && !value" type="checkbox" (change)="onValueChanged()">

    <input *ngIf="disabled && !value" type="checkbox" disabled [ngClass]="{'view': dataGridView}">
    <input *ngIf="disabled && value" type="checkbox" disabled checked [ngClass]="{'view': dataGridView}">

    <span class="slider"></span>
</label>